import React from 'react';
import EcoTitle from 'eco-design/base/eco-title';
import EcoImg from 'eco-design/base/eco-img';
import { useProductStore } from '../../../../ProductProvider';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const OnePicture: React.FC = ({}) => {

    const { t } = useLang('theProductV2.OnePicture');
    const { pageStatus } = useProductStore();
    const webpOrJpg = useWebpOrJpg('#rapid-mag-OnePicture-V2');
    const cards = [
        {
            label: t('item1_label'),
            title: t('item1_title'),
            desc: t('item1_desc'),

            jpg: ['https://websiteoss.ecoflow.com/upload/image/1762502897844/1.png', 'https://websiteoss.ecoflow.com/upload/image/1761293481285/grid-1-h5.png'],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1762502898504/1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293751267/grid-1-h5.png',
            ],
        },
        
         {
            title: t('item2_title'),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1764581628363/Frame%201612689870.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1764583327679/card3-h5.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1764582253101/Frame%20161269784.webp',
                'https://websiteoss.ecoflow.com/upload/image/1764583344652/card3W-h5.webp',
            ],
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1761293441648/grid-3.png',
                'https://websiteoss.ecoflow.com/upload/image/1761293481748/grid-3-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1761293703873/grid-3.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293777552/grid-3-h5.png',
            ],
        },
        {
            title: t('item4_title'),
            jpg: ['https://websiteoss.ecoflow.com/upload/image/1764583278777/card1-pc.jpg', 'https://websiteoss.ecoflow.com/upload/image/1764583327086/card1-h5.jpg'],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1764583267001/card1W-pc.webp',
                'https://websiteoss.ecoflow.com/upload/image/1764583343923/card1W-h5.webp',
            ],
        },
        {
            title: t.rich('item5_title', {
                b: (v: string) => <span className="blod">{v}</span>,
            }),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1761293442736/grid-5.png',
                'https://websiteoss.ecoflow.com/upload/image/1761293482145/grid-5-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1761293704449/grid-5.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293808601/grid-5-h5.png',
            ],
        },
        {
            label: t('item6_label'),
            title: t('item6_title'),
            icon: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1764920078029/icon.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1764920239636/icon.webp',
            ),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1764583306943/card2-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1764583344232/card2W-h5.webp',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1764583267374/card2W-pc.webp',
                'https://websiteoss.ecoflow.com/upload/image/1764583344232/card2W-h5.webp',
            ],
        },
    ];




    return (
        <section
            className={`${css.section} rapid-mag-OnePicture-V2 GtmModuleData-section`}
            id="rapid-mag-OnePicture-V2"
            data-section-id={'rapid-mag-OnePicture-V2'}
            data-section-title={t('title')}
        >
            <div className="title-box">
                <EcoTitle title={t('title_V1')} className="title-v1"/>
                <EcoTitle title={t('title_V2')} className="title-v2"/>
            </div>
            
           
             <div className="onePicture-content">
                {!['statusC'].includes(pageStatus) && (
                    <div className="head-card">
                        <div className="head-info">
                            <div className="head-title">{t('head_title')}</div>
                            <div className="head-desc">{t('head_desc')}</div>
                        </div>
                        <EcoImg
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498946818/head-pc.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946635/head-pc.webp',
                            )}
                            pad={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498946818/head-pc.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946635/head-pc.webp',
                            )}
                            h5={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498945755/head-m.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946022/head-m.webp',
                            )}
                        />
                    </div>
                )}
                <div className="one-pricture-grid">
                    {cards.map((i, idx) => (
                        <div className={`grid-item grid-item-${idx + 1}`} key={idx}>
                            <EcoImg pc={webpOrJpg(i.jpg[0], i.webp[0])} pad={webpOrJpg(i.jpg[0], i.webp[0])} h5={webpOrJpg(i.jpg[1], i.webp[1])}/>
                            {i.label && <div className="grid-label">{i.label}</div>}
                            {i.title && <div className="grid-title">{i.title}</div>}
                            {i.desc && <div className="grid-desc">{i.desc}</div>}
                            {i.icon && (
                                <div className="grid-icon">
                                    <img src={webpOrJpg(i.icon)} alt="" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
export default OnePicture;
